/**
 * The cue that the wake word was heard: two short rising tones, made with
 * WebAudio (no asset to ship, theme-independent). Best effort — a browser
 * that refuses audio here still starts the call.
 */
export function playWakeChime(): void {
  try {
    const ctx = new AudioContext();
    const now = ctx.currentTime;
    [660, 880].forEach((hz, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.frequency.value = hz;
      gain.gain.setValueAtTime(0.0001, now + i * 0.12);
      gain.gain.exponentialRampToValueAtTime(0.15, now + i * 0.12 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + i * 0.12 + 0.11);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + i * 0.12);
      osc.stop(now + i * 0.12 + 0.12);
    });
    window.setTimeout(() => void ctx.close(), 500);
  } catch {
    // No audio output available: the orb still shows the call starting.
  }
}
